import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { action, observable } from 'mobx';
import { fromEvent, merge, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { defaultCancellationToken } from '../utils/cancellation';
import { toStream } from '../utils/mobxUtil';
import { shareLatest } from '../utils/rxUtil';
export var SoundId = {
  GotMessage: 'GotMessage',
  IncomingCall: 'IncomingCall',
  RingingCall: 'RingingCall'
};
var sounds = new Map([[SoundId.GotMessxage, {
  mp3: require('./sounds/got-message.mp3'),
  ogg: require('./sounds/got-message.ogg')
}], [SoundId.IncomingCall, {
  mp3: require('./sounds/bell_ring.mp3'),
  ogg: require('./sounds/bell_ring.ogg')
}], [SoundId.RingingCall, {
  mp3: require('./sounds/ringback_tone.mp3'),
  ogg: require('./sounds/ringback_tone.ogg')
}]]);
var SoundPlayer = (_class = /*#__PURE__*/function () {
  function SoundPlayer(storage) {
    var _this = this;
    _classCallCheck(this, SoundPlayer);
    /**
     * Whether system sounds are enabled.
     */
    _initializerDefineProperty(this, "isEnabled", _descriptor, this);
    /**
     * We can only play sound once we have interacted with the document at least once.
     * We emit the first interaction.
     */
    this.ready$ = merge(fromEvent(window, 'mousedown', {
      capture: true
    }), fromEvent(window, 'click', {
      capture: true
    }), fromEvent(window, 'keypress', {
      capture: true
    }), fromEvent(window, 'touchstart', {
      capture: true
    })).pipe(
    // Unsubscribe after the first interaction.
    take(1),
    // Once we have the first one, just emit that on subscribe.
    shareLatest());
    this.storage = storage;
    this.setEnabled(storage.getItem('soundEnabled') !== 'disabled');
    toStream(function () {
      return _this.isEnabled;
    }).subscribe(function (enabled) {
      return _this.storage.setItem('soundEnabled', enabled ? 'enabled' : 'disabled');
    });
    // Initialize all audio objects
    var _iterator = _createForOfIteratorHelper(sounds),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 1),
          sound = _step$value[0];
        SoundPlayer.getAudio(sound);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    this.ready$.subscribe();
  }

  /**
   * Toggles whether the sound player is enabled.
   *
   * @param enabled
   */
  return _createClass(SoundPlayer, [{
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.isEnabled = enabled;
    }

    /**
     * Play a sound.
     *
     * @param {SoundId} id
     */
  }, {
    key: "play",
    value: function play(id) {
      this.getSound(id).play(defaultCancellationToken);
    }

    /**
     * Gets a sound by ID.
     * @param {SoundId} id
     * @returns {Sound}
     */
  }, {
    key: "getSound",
    value: function getSound(id) {
      var _this2 = this;
      var _play = function play(loop, ct) {
        if (!_this2.isEnabled) {
          return;
        }
        var audio = SoundPlayer.getAudio(id);
        audio.loop = loop;
        if (ct.isCancelled) {
          return;
        }

        // Prevents some stupid DOMException, only way to do it.
        // When in doubt, setTimeout
        ct.onCancel(function () {
          audio.pause();
        });
        _this2.ready$.pipe(takeUntil(
        // If it takes more than 2 seconds to be ready,
        // just ignore it.
        merge(ct.asObservable(), timer(2000))), take(1)).subscribe(function () {
          audio.currentTime = 0;
          audio.play();
        });
      };
      return {
        play: function play(ct) {
          _play(false, ct);
        },
        playLoop: function playLoop(ct) {
          _play(true, ct);
        }
      };
    }

    /**
     * Gets the audio object for the specified sound.
     *
     * @param id
     */
  }], [{
    key: "getAudio",
    value: function getAudio(id) {
      var audio = new window.Audio();
      var type = audio.canPlayType('audio/mpeg') ? 'mp3' : 'ogg';
      audio.volume = 0.6;
      audio.src = sounds.get(id)[type];
      audio.pause();
      return audio;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setEnabled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setEnabled"), _class.prototype), _class);
export { SoundPlayer as default };
//# sourceMappingURL=SoundPlayer.js.map
